package com.example.readingnotes.presentation.auth

import com.example.readingnotes.domain.model.User

data class AuthUiState(
    val isLoading: Boolean = false,
    val isLoggedIn: Boolean = false,
    val errorMessage: String? = null,
    val passwordInput: String = "",
    // New fields for username authentication
    val usernameInput: String = "",
    val user: User? = null,
    val usernameAvailable: Boolean? = null, // null = not checked, true = available, false = taken
    val usernameChecking: Boolean = false, // loading state for username check
    // TOTP fields
    val totpCodeInput: String = "",
    val totpRequired: Boolean = false,
    val totpVerified: Boolean = false,
    val totpSetupSecret: String? = null,
    val totpSetupQrCodeUrl: String? = null,
    // Email authentication fields
    val emailInput: String = "",
    val verificationCodeInput: String = "",
    val verificationCodeSent: Boolean = false,
    val emailVerified: Boolean = false,
    val tempEmail: String = "", // temporary email during registration flow
    val tempVerificationCode: String = "", // temporary verification code during registration flow
)
